module.exports = __webpack_public_path__ + "img/M551.1c2a1369.jpg";